export const EMPTY_OPEN_INVITE_VALUE = Object.freeze({
  isOpenInvite: false,
  joinMode: 'review',
  maxPlayers: 4,
  audienceAllFriends: false,
  audienceAllGroups: false,
  friendIds: [],
  groupIds: [],
});
